import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Calendar } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);
  return (
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16" data-testid="blog-page">
      <p className="label-mono mb-3">555 Journal</p>
      <h1 className="font-display text-4xl md:text-6xl font-light tracking-tighter mb-12">Notes from the broker desk.</h1>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((p) => (
          <Link to={`/blog/${p.slug}`} key={p.slug} data-testid={`blog-card-${p.slug}`} className="group block bg-[#0A0A0E] border border-[#1A1A24] rounded-2xl overflow-hidden hover-lift hover:border-white/20">
            <div className="aspect-[16/10] overflow-hidden bg-[#12121A]">
              <img src={p.image_url} alt="" className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
            </div>
            <div className="p-6">
              <div className="label-mono mb-3">{p.category}</div>
              <h3 className="font-display text-xl leading-snug mb-3">{p.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed line-clamp-3">{p.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
